import { render, staticRenderFns } from "./allocation.vue?vue&type=template&id=48d7f2b1"
import script from "./allocation.vue?vue&type=script&lang=js"
export * from "./allocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d7f2b1')) {
      api.createRecord('48d7f2b1', component.options)
    } else {
      api.reload('48d7f2b1', component.options)
    }
    module.hot.accept("./allocation.vue?vue&type=template&id=48d7f2b1", function () {
      api.rerender('48d7f2b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/entryDesign/allocation.vue"
export default component.exports